// extracted by mini-css-extract-plugin
export default {"fullWidth":"vn-z","image":"wn-z","lazyLoadPicture":"xn-z","lazyLoadSpinner":"yn-z","lazyLoadSpin":"zn-z","lazyLoadImage":"An-z","hasStyledAspectRatio":"Bn-z"};